(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const form = document.getElementById('FooterLocaleForm');
  const countryInput = form && form.querySelector('input[name="country_code"]');
  if (form && countryInput) {
    form.querySelectorAll('button[data-country]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        countryInput.value = button.getAttribute('data-country');
        form.submit();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MIN_PX = 12;
    var STEP = 0.5;

    function fitQuote(quote) {
      quote.style.fontSize = '';
      quote.style.lineHeight = '';
      var computed = window.getComputedStyle(quote);
      var start = parseFloat(computed.fontSize);
      var line = parseFloat(computed.lineHeight);
      var ratio = start > 0 && line > 0 ? line / start : 1.2;
      var size = start;

      while (quote.scrollHeight > quote.clientHeight + 1 && size > MIN_PX) {
        size -= STEP;
        quote.style.fontSize = size + 'px';
        quote.style.lineHeight = size * ratio + 'px';
      }
    }

    function fitAll(root) {
      root.querySelectorAll('.reviews__quote').forEach(fitQuote);
    }

    function bind(root) {
      if (!root || root.dataset.reviewsFitBound === 'true') return;
      root.dataset.reviewsFitBound = 'true';

      var run = function () {
        fitAll(root);
      };

      run();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run);
      }

      if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', run);
        return;
      }

      var observer = new ResizeObserver(run);
      root.querySelectorAll('.reviews__card').forEach(function (card) {
        observer.observe(card);
      });
    }

    document.querySelectorAll('slider-component.reviews').forEach(bind);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (section.matches && section.matches('slider-component.reviews')) {
        bind(section);
        return;
      }
      if (section.querySelectorAll) {
        section.querySelectorAll('slider-component.reviews').forEach(bind);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
